import { amber, blue, green } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import * as Actions from 'app/store/actions';
import clsx from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'app/modules/react-redux';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
	root: {},
	success: {
		backgroundColor: green[600],
		color: '#FFFFFF',
	},
	approval: {
		backgroundColor: green[600],
		color: '#FFFFFF',
	},
	error: {
		backgroundColor: theme.palette.error.dark,
		color: theme.palette.getContrastText(theme.palette.error.dark),
	},
	info: {
		backgroundColor: blue[600],
		color: '#FFFFFF',
	},
	warning: {
		backgroundColor: amber[600],
		color: '#FFFFFF',
		alignItems: 'flex-start',
	},
	action: {
		marginTop: 2,
	},
}));

const variantIcon = {
	success: '',
	warning: <WarningIcon color="inherit" />,
	error: <ErrorIcon color="inherit" />,
	info: <InfoIcon color="inherit" />,
	approval: <CheckCircleIcon color="inherit" />,
};

const FuseMessage = (_props) => {
	const { t } = useTranslation('alert');
	const dispatch = useDispatch();
	const state = useSelector(({ fuse }) => fuse.message.state);
	const options = useSelector(({ fuse }) => fuse.message.options);

	const classes = useStyles();

	const message =
		['error', 'warning'].includes(options.variant) && typeof options.message === 'string'
			? (options.message ?? 'something went wrong')
			: options.message;

	return (
		<Snackbar
			{...options}
			open={state}
			onClose={() => dispatch(Actions.hideMessage())}
			classes={{
				root: classes.root,
			}}
		>
			<SnackbarContent
				className={clsx(classes[options.variant])}
				message={
					<div className="flex items-start">
						{variantIcon[options.variant] && variantIcon[options.variant]}
						<Typography className="mx-8">{typeof message === 'string' ? t(message) : message}</Typography>
					</div>
				}
				action={
					<IconButton
						key="close"
						aria-label="Close"
						color="inherit"
						className={classes.action}
						size="small"
						onClick={() => dispatch(Actions.hideMessage())}
					>
						<CloseIcon />
						{/* <Icon>close</Icon> */}
					</IconButton>
				}
			/>
		</Snackbar>
	);
};

export default React.memo(FuseMessage);
